import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { veiculosService } from '../../services';

export const VeiculosFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Veículo"
      service={veiculosService}
      redirectPath="/admin/logistica/veiculos"
      fields={[
        { name: 'tipo', label: 'Tipo', type: 'select', required: true, options: [
          { value: 'CAMINHAO', label: 'Caminhão' },
          { value: 'REBOQUE', label: 'Reboque' },
          { value: 'CARRETA', label: 'Carreta' },
          { value: 'VAN', label: 'Van' },
          { value: 'UTILITARIO', label: 'Utilitário' },
          { value: 'OUTRO', label: 'Outro' },
        ]},
        { name: 'placa', label: 'Placa', type: 'text', required: true },
        { name: 'renavam', label: 'RENAVAM', type: 'text' },
        { name: 'marca', label: 'Marca', type: 'text' },
        { name: 'modelo', label: 'Modelo', type: 'text' },
        { name: 'ano_fabricacao', label: 'Ano de Fabricação', type: 'number' },
        { name: 'capacidade_kg', label: 'Capacidade (kg)', type: 'number' },
        { name: 'capacidade_m3', label: 'Capacidade (m³)', type: 'number' },
        { name: 'eixos', label: 'Número de Eixos', type: 'number' },
        { name: 'status', label: 'Status', type: 'select', options: [
          { value: 'ATIVO', label: 'Ativo' },
          { value: 'MANUTENCAO', label: 'Em Manutenção' },
          { value: 'INATIVO', label: 'Inativo' },
          { value: 'VENDIDO', label: 'Vendido' },
        ]},
        { name: 'observacoes', label: 'Observações', type: 'textarea' },
      ]}
    />
  );
};
